import { useAppSelector } from '@web-solutions/store/types';

export const useLocale = () => {
  return useAppSelector((state) => state.locale);
};
